import React from 'react';
import ServicesSection from '../components/ServicesSection.jsx';

function Services() {
  return (
    <div>
      <ServicesSection />
    </div>
  );
}

export default Services;